export const pageEventsConfig = {
    parentSelector: 'body',
    events: {
        // Applications page events
        applicationsProductCard: {
            selector: '.template-page--applications .card__heading a',
            event: {
                event: 'user_interaction',
                component: 'product_card',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    product_name: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },

        applicationsCollectionCard: {
            // parentSelector: '.template-page--applications',
            selector: 'a.full-unstyled-link',
            event: {
                event: 'user_interaction',
                component: 'collection_card',
                element: 'card',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    field: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },

        // About DCP page events
        aboutDCPLinkedIn: {
            selector: 'a.link.animate-arrow',
            event: {
                event: 'user_interaction',
                component: '',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    field: 'Our team',
                    link_text: 'LinkedIn',
                    link_url: element.href
                })
            }
        },

        // Contact page events
        contactEmail: {
            // parentSelector: '.template-page--contact',
            selector: 'a[href^="mailto:"]',
            event: {
                event: 'user_interaction',
                component: '',
                element: 'mail',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    action_value: element.textContent.trim()
                })
            }
        },

        // Request Sample page events
        requestSampleLink: {
            selector: '.template-page--request-sample a[href*="business-account"]',
            event: {
                event: 'user_interaction',
                component: '',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_text: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },

        registeredCompaniesLink: {
            selector: 'a[href*="https://dcp-chemicals.com/pages/zakelijk-account"]',
            event: {
                event: 'user_interaction',
                component: '',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_text: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },

        // Generic page CTA buttons
        pageCTA: {
            selector: '.button--primary',
            event: {
                event: 'user_interaction',
                component: '',
                element: 'button',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    field: element.closest('.banner__box')?.querySelector('.banner__heading')?.textContent.trim() || '',
                    action_value: element.textContent.trim(),
                    link_url: element.href
                })
            }
        },

        contactFormLinks: {
            parentSelector: '.custom-contact__grid-content',
            selector: 'a[href*="/pages/"]',
            event: {
                event: 'user_interaction',
                component: '',
                element: 'link',
                action: 'click',
                trigger: 'click',
                getDynamicData: (element) => ({
                    link_text: element.textContent.trim(),
                    link_url: element.href,
                    field: element.title || element.textContent.trim()
                })
            }
        }
    }
}; 